import { render, staticRenderFns } from "./iOS.vue?vue&type=template&id=0032b36e"
import script from "./iOS.vue?vue&type=script&lang=js"
export * from "./iOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports